/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MicrosoftIntegrationCustomerData
 */
export interface MicrosoftIntegrationCustomerData {
    /**
     * 
     * @type {string}
     * @memberof MicrosoftIntegrationCustomerData
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftIntegrationCustomerData
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftIntegrationCustomerData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MicrosoftIntegrationCustomerData
     */
    remoteNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MicrosoftIntegrationCustomerData
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the MicrosoftIntegrationCustomerData interface.
 */
export function instanceOfMicrosoftIntegrationCustomerData(value: object): value is MicrosoftIntegrationCustomerData {
    return true;
}

export function MicrosoftIntegrationCustomerDataFromJSON(json: any): MicrosoftIntegrationCustomerData {
    return MicrosoftIntegrationCustomerDataFromJSONTyped(json, false);
}

export function MicrosoftIntegrationCustomerDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MicrosoftIntegrationCustomerData {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'remoteNumber': json['remoteNumber'] == null ? undefined : json['remoteNumber'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function MicrosoftIntegrationCustomerDataToJSON(json: any): MicrosoftIntegrationCustomerData {
    return MicrosoftIntegrationCustomerDataToJSONTyped(json, false);
}

export function MicrosoftIntegrationCustomerDataToJSONTyped(value?: MicrosoftIntegrationCustomerData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'remoteNumber': value['remoteNumber'],
        'enabled': value['enabled'],
    };
}

